import { ReactComponent as WAIcon } from 'assets/images/icons/whatsapp-icon.svg';

import { useZappieChip } from './hooks';

import makeClasses from './ZappieChip.style';

import type { ZappieChipSize } from './zappieChip.type';

export function ZappieChip(props: Props) {
  const { size = 'regular' } = props;

  const { lang, isRender } = useZappieChip();

  const _classes = makeClasses({ size });

  if (!isRender) return null;
  return (
    <div
      role='status'
      aria-live='polite'
      aria-label='zappie-chip'
      className={_classes.root}
    >
      <WAIcon aria-label='icon' />
      <span aria-label='label'>{lang.label}</span>
    </div>
  );
}

interface Props {
  // 'regular' as default
  size?: ZappieChipSize;
}
